import { provide } from '@/util/container';
import { OBJECT_LIST_MAPPER } from '.';
import ObjectListMapper from '@/features/app-enterprise-project/views/enterprise-project/imports/object-list-mapper';

export default provide(OBJECT_LIST_MAPPER, async () => {
  return new ObjectListMapper();
});
